export const FIELD_TYPES = [
  ["short_text", "Short Text", "One line of text, up to 255 characters."],
  [
    "long_text",
    "Long Text",
    "Multiple lines, up to 1,000 characters; profiles show a three-line preview with View full text.",
  ],
  ["integer", "Integer", "Whole numbers only; fractional values are rejected."],
  [
    "decimal",
    "Decimal",
    "Numbers with up to six decimal places; values are not silently rounded.",
  ],
  ["percentage", "Percentage", "Percentage points: 12.5 displays as 12.5%."],
  [
    "currency_usd",
    "Currency (USD)",
    "U.S. dollar major units: 12.34 means $12.34; no conversion or alternate currencies.",
  ],
  ["date", "Date", "A calendar date without a time or timezone conversion."],
  [
    "boolean",
    "Yes/No",
    "Yes, No, or Unset; No is retained as a value, not treated as empty.",
  ],
  [
    "single_select",
    "Single-select",
    "One choice from the field's active options.",
  ],
  [
    "multi_select",
    "Multi-select",
    "Multiple unique choices, displayed in configured option order.",
  ],
];

export const NUMERIC_TYPES = [
  "integer",
  "decimal",
  "percentage",
  "currency_usd",
];
export const NUMERIC_INPUT_HINTS = {
  integer:
    "Enter a whole number, such as 12 or -12. Do not use decimal points or commas.",
  decimal:
    "Enter a number with up to 6 decimal places, such as 12.5 or -0.25. Use a period, not a comma.",
  percentage: "Enter percentage points: 12.5 means 12.5%.",
};
export const SELECT_TYPES = ["single_select", "multi_select"];
export const comparableValue = (value) =>
  JSON.stringify(
    Array.isArray(value) ? value.map(String).sort() : (value ?? null),
  );
export const TYPE_LOCK_HELP =
  "Choose carefully. After the first contact value is saved, the field type cannot be changed, even if its values are later cleared.";
